import {
  Box,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';
import { FC } from 'react';
import { HeaderContainer } from '../dashboard/AgentInfoHeader';

export type PhoneNumbersEnvironment = 'trial' | 'production';

interface PhoneHeaderProps {
  selectedEnvironment: PhoneNumbersEnvironment;
  onEnvironmentChange: (environment: PhoneNumbersEnvironment) => void;
}

const PhoneHeader: FC<PhoneHeaderProps> = ({
  selectedEnvironment,
  onEnvironmentChange,
}) => {
  const handleEnvironmentChange = (
    _event: React.MouseEvent<HTMLElement>,
    newValue: string | null
  ) => {
    if (newValue === 'trial' || newValue === 'production') {
      onEnvironmentChange(newValue);
    }
  };

  return (
    <HeaderContainer>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="h6"
          color="custom.textBlue"
          sx={{ fontSize: '24px', fontWeight: 600 }}
        >
          Available Phone Numbers
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography
            sx={{
              mr: 1,
              fontSize: '12px',
              fontWeight: 400,
              color: 'text.secondary',
            }}
          >
            Numbers
          </Typography>
          <ToggleButtonGroup
            value={selectedEnvironment}
            exclusive
            onChange={handleEnvironmentChange}
            aria-label="phone numbers environment"
            sx={{
              backgroundColor: '#DCE0E7',
              borderRadius: '8px',
              padding: '4px',
              border: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              height: '34px',
              minWidth: '160px',
              '& .MuiToggleButton-root': {
                border: 'none',
                borderRadius: '6px',
                textTransform: 'none',
                py: '8px',
                px: '16px',
                fontSize: '14px',
                height: '26px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s ease-in-out',
                fontWeight: 400,
                color: '#4E5A6B',
                '&.Mui-selected': {
                  backgroundColor: '#FFF',
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#2B2F32',
                  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
                },
                '&:hover': {
                  backgroundColor: '#F5F5F5',
                },
              },
            }}
          >
            <ToggleButton
              value="trial"
              sx={{
                fontFamily: 'DM Sans',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '100%',
                letterSpacing: '-1%',
                textAlign: 'center',
              }}
            >
              Trial
            </ToggleButton>
            <ToggleButton
              value="production"
              sx={{
                fontFamily: 'DM Sans',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '100%',
                letterSpacing: '-1%',
                textAlign: 'center',
              }}
            >
              Production
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
      </Box>
    </HeaderContainer>
  );
};

export default PhoneHeader;
